import { Outlet } from 'react-router';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import StickyLinearProgress from "../../loading/StickyLinearProgress.tsx";
import { useContext } from "react";
import { AppFwAppProviderProps, AppFwAppProviderPropsContext } from "../../AppFwApp.tsx";
import { DashboardLayoutProps } from "@toolpad/core";


export default function DefaultAppFwLayout(props: DashboardLayoutProps) {
    const appFwAppProviderProps = useContext<AppFwAppProviderProps>(AppFwAppProviderPropsContext)
    return (
        <DashboardLayout {...props}>
            <StickyLinearProgress />
            {props.children ?? appFwAppProviderProps.children ?? <Outlet />}
            {/*<PageContainer>*/}
            {/*    <Outlet />*/}
            {/*</PageContainer>*/}
        </DashboardLayout>
    )
}